import React from "react";
import bgImg from "../Images/hero.jpeg";
import image2 from "../Images/image2.jpeg";
import image3 from "../Images/image3.jpeg";
import image4 from "../Images/image4.jpeg";

const projects = [
  {
    title: "PVC Pipes",
    desc: "DELSON PVC Pipes are manufactured using high-quality raw materials to ensure strength, durability, and long-lasting performance. These pipes are leak-proof, corrosion-resistant, and lightweight, making them ideal for water supply, plumbing, agriculture, and industrial applications.",
    img: image2,
  },
  {
    title: "Pipes",
    desc: "These PVC/CPVC pipes are manufactured using high-quality materials to ensure excellent strength, durability, and long service life. They are designed with a smooth inner surface that allows efficient water flow, reduces friction, and minimizes the risk of blockage.",
    img: image3,
  },
  {
    title: "Dellson Garden pipe",
    desc: "The Dellson garden pipe is a durable and flexible watering solution designed for everyday gardening and outdoor use. Made from high-quality materials, it offers strong resistance to pressure, cracking, and weather damage, ensuring long-lasting performance.",
    img: image4,
  },
  {
    title: "Motors",
    desc: "These electric motors are manufactured using high-quality components and advanced engineering to deliver efficient, reliable, and long-lasting performance. They are designed to provide smooth operation, high torque, and consistent output while consuming optimal power.",
    img: "https://tse4.mm.bing.net/th/id/OIP.jU_tpi3qRHr4MR60ioli3QHaHa?pid=Api&P=0&h=180",
  },
];

const Product = () => {
  return (
    <section className="py-5 bg-light">
      <div className="container">

        {/* Heading */}
        <div className="text-center mb-5">
          <h2
            className="fw-bold"
            style={{ color: "#224b8f" }}
          >
            Our Product Range
          </h2>
          <p className="text-muted mt-2">
            With years of experience and commitment to excellence, we deliver
            quality plumbing solutions you can trust.
          </p>
        </div>

        {/* Cards */}
        <div className="row g-4">
          {projects.map((item, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="card h-100 shadow-sm border-0">
                <img
                  src={item.img}
                  className="card-img-top"
                  alt={item.title}
                  style={{ height: "220px", objectFit: "cover" }}
                />
                <div className="card-body text-center">
                  <h5
                    className="card-title fw-semibold"
                    style={{ color: "#224b8f" }}
                  >
                    {item.title}
                  </h5>
                  <p className="card-text text-muted">
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Product;
